export const getCookieDomain = `.${window.location.hostname.split('.').slice(-2).join('.')}`;
